// crewbit-admin/src/components/money/settings/BrandingPanel.tsx
//
// Branding group sub-screen body. Sibling-pattern shell mirroring
// PaidPanel / TaxesPanel / etc — wraps the shared <InvoiceBrandingForm />
// with no additional editor logic. The form owns field set + writer per
// §SESSION_INVOICE_SETTINGS_LEGACY_RETIREMENT D2 + D3.

import { InvoiceBrandingForm } from '../branding/InvoiceBrandingForm';

interface BrandingPanelProps {
  businessId: string | null;
}

export default function BrandingPanel({ businessId }: BrandingPanelProps) {
  return <InvoiceBrandingForm businessId={businessId ?? undefined} />;
}
